import { feedbackModalReducer } from 'src/modules/feedback/reducers/feedbackModalReducer';
import { feedbackTriggerReducer } from 'src/modules/feedback/reducers/feedbackTriggerReducer';
import { FeedbackState } from 'src/modules/feedback/types/FeedbackState';
import { chainReducers } from 'src/utils/chainReducers';

const defaultState: FeedbackState = {
  feedbackModalOpened: false,
};

export const feedbackReducer = chainReducers(defaultState, [
  feedbackModalReducer,
  feedbackTriggerReducer,
]);
